import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <p className="footer-text">&copy; {new Date().getFullYear()} Creative Portfolio. All rights reserved.</p>
                    <p className="footer-text">Designed & Developed with <span className="heart">♥</span></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
